import Raven from 'raven-js';
import { rpcClient } from '../../rpcClient';
import { getProductsRpc } from '../../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc';
export const fetchProducts = (productApiNames, skuCategoryName) => {
  let products = [];
  let promiseError = undefined;

  // Free api names (e.g. "marketing-hub-free") are a concept supported
  // exclusively by the feature store service.
  const purchasableApiNames = productApiNames.filter(apiName => !apiName.includes('free'));
  return rpcClient.call(getProductsRpc, {
    request: {
      productApiNames: purchasableApiNames
    }
  }).then(productsResponse => {
    products = Object.entries(productsResponse.productsByName).map(([productApiName, product]) => Object.assign({}, product, {
      productApiName
    }));
  }, error => {
    promiseError = error;
    Raven.captureException(new Error(error.message, {
      cause: error
    }), {
      extra: {
        productApiNames
      }
    });
  }).catch(error => {
    promiseError = error;
    Raven.captureException(new Error('fetchProducts: Promise successfully resolved but the catch block was triggered', {
      cause: error
    }), {
      extra: {
        productApiNames
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    const areAllProductsInSameProductLine = products && products.length > 0 && products.every(product => product.skuCategoryName === skuCategoryName);
    if (!areAllProductsInSameProductLine) {
      // Reset products to an empty array to prevent downstream fetches from
      // being fired
      products = [];
      const invalidProductApiNamesError = new Error(`Product details for ${purchasableApiNames.join(', ')} do not match the expected skuCategoryName: ${skuCategoryName}`);
      console.error(invalidProductApiNamesError);
      Raven.captureException(invalidProductApiNamesError, {
        extra: {
          productApiNames,
          skuCategoryName
        }
      });
    }
    return products;
  });
};